import { Directive, AfterViewInit, ElementRef, inject } from '@angular/core';

@Directive({
  standalone: true,
  selector: '[appHtmlFormatter]'
})
export class HtmlFormatterDirective implements AfterViewInit {

  private el = inject(ElementRef);

  ngAfterViewInit() {
    let peeps = this.el.nativeElement.querySelectorAll('p');
    if (peeps) {
      for (let p of peeps) {
        p.style.fontSize = '1em';
      }
    }
  }

}
